(() => {
  'use strict';

  if (window.HomewoodsMeasurements) return;

  const PANEL_HEIGHT_CM = 270;
  const PANEL_WIDTH_CM = 110;
  const PANEL_AREA_M2 = PANEL_HEIGHT_CM * PANEL_WIDTH_CM / 10000;
  const SQUARE_METRES_PER_SQUARE_FOOT = 0.09290304;
  const localPreview = location.protocol === 'file:' || ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
  const imperialCountries = new Set(['US', 'PR', 'VI', 'GU', 'AS', 'MP']);
  let marketCountry = '';
  let country = '';
  let system = 'metric';

  function countryCode(value) {
    const code = typeof value === 'string' ? value.trim().toUpperCase() : '';
    return /^[A-Z]{2}$/.test(code) ? code : '';
  }

  function browserCountry() {
    try {
      return countryCode(new Intl.Locale(navigator.language).region);
    } catch {
      return '';
    }
  }

  function resolveCountry() {
    const previewCountry = localPreview ? countryCode(new URL(location.href).searchParams.get('country')) : '';
    return previewCountry || marketCountry
      || countryCode(document.documentElement.dataset.hwCountry)
      || countryCode(window.Shopify?.country)
      || countryCode(document.querySelector('form[action*="localization"] [name="country_code"]')?.value)
      || browserCountry();
  }

  function number(value, digits) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(value);
  }

  function dimensions() {
    return system === 'imperial'
      ? `${number(PANEL_HEIGHT_CM / 2.54, 1)} × ${number(PANEL_WIDTH_CM / 2.54, 1)} in`
      : `${PANEL_HEIGHT_CM} × ${PANEL_WIDTH_CM} cm`;
  }

  function area(squareMetres) {
    if (!Number.isFinite(squareMetres) || squareMetres < 0) return '—';
    return system === 'imperial'
      ? `${number(squareMetres / SQUARE_METRES_PER_SQUARE_FOOT, 2)} sq ft`
      : `${number(squareMetres, 2)} m²`;
  }

  function panelArea(quantity = 1) {
    return area(quantity * PANEL_AREA_M2);
  }

  function panelDetails() {
    return HWT`${dimensions()} · ${panelArea()} per panel`;
  }

  function render(root = document) {
    const elements = Array.from(root.querySelectorAll('[data-hw-measure]'));
    if (root instanceof Element && root.matches('[data-hw-measure]')) elements.unshift(root);
    elements.forEach((element) => {
      const value = element.dataset.hwMeasure === 'dimensions' ? dimensions()
        : element.dataset.areaM2 ? area(Number(element.dataset.areaM2))
          : panelArea(Number(element.dataset.panelCount || 1));
      element.textContent = value + (element.dataset.hwMeasureSuffix || '');
    });
  }

  function refresh() {
    const nextCountry = resolveCountry();
    const nextSystem = imperialCountries.has(nextCountry) ? 'imperial' : 'metric';
    const changed = nextCountry !== country || nextSystem !== system;
    country = nextCountry;
    system = nextSystem;
    document.documentElement.dataset.hwMeasurementSystem = system;
    render();
    if (changed) document.dispatchEvent(new CustomEvent('homewoods:measurements-change', { detail: { country, system } }));
  }

  window.HomewoodsMeasurements = Object.freeze({
    dimensions, area, panelArea, panelDetails, render, refresh,
    panelAreaM2: PANEL_AREA_M2,
    get country() { return country; },
    get system() { return system; }
  });

  document.addEventListener('homewoods:market-change', (event) => {
    const code = countryCode(event.detail?.country);
    if (!code) return;
    marketCountry = code;
    refresh();
  });
  document.addEventListener('shopify:section:load', () => refresh());
  window.addEventListener('pageshow', refresh);
  window.addEventListener('popstate', refresh);
  window.addEventListener('languagechange', refresh);
  new MutationObserver(refresh).observe(document.documentElement, { attributes: true, attributeFilter: ['data-hw-country'] });
  refresh();
})();

